import { useState, useEffect, useMemo } from 'react';
import styles from '../App.module.css';
import api from '../api/axios';
import Countries from '../countries';
import { FaPencilAlt, FaTrashAlt, FaExclamation } from 'react-icons/fa';
import { IoCloseSharp } from 'react-icons/io5';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import '../css/notifications.css';
import Usuarios from '../components/Usuarios/Usuarios';
import CreateCliente from '../components/Usuarios/CreateCliente';
import { isAuthenticated } from '../../src/index';
import notifications from '../components/notifications';
import Agendamentos, { openModal } from '../components/agendamentos';
import { format, parseISO } from 'date-fns';

function addZeroes(num, len) {
  let numberWithZeroes = String(num);
  while (numberWithZeroes.length < len) {
    numberWithZeroes = `0${numberWithZeroes}`;
  }
  return numberWithZeroes;
}

function Monitorar() {
  const [countriesList] = useState(Countries);
  const [notificationType, setNotificationType] = useState(0);

  const pickDate = new Date();
  const pickDatePlus = new Date();
  pickDatePlus.setDate(pickDatePlus.getDate() + 90);

  const { userPermission, userStatus } = isAuthenticated();

  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [grupo, setGrupo] = useState("");
  const [cidade, setCidade] = useState([]);
  const [limiteAntecedencia, setLimiteAntecedencia] = useState("0");
  const [anoMarcado, setAnoMarcado] = useState(pickDatePlus.getFullYear());
  const [mesMarcado, setMesMarcado] = useState(addZeroes(pickDatePlus.getMonth() + 1, 2));
  const [diaMarcado, setDiaMarcado] = useState(addZeroes(pickDatePlus.getDate(), 2));
  const [anoBloqueado, setAnoBloqueado] = useState(pickDate.getFullYear());
  const [mesBloqueado, setMesBloqueado] = useState(addZeroes(pickDate.getMonth() + 1, 2));
  const [diaBloqueado, setDiaBloqueado] = useState(addZeroes(pickDate.getDate(), 2));
  const [obs, setObs] = useState("");
  const [pais, setPais] = useState("pt-br");
  const [conta, setConta] = useState("");
  const [status, setStatus] = useState(0);
  const [vendedor, setVendedor] = useState("0");
  const [clienteId, setClienteId] = useState("");

  const [userIdMonitorar, setUserIdMonitorar] = useState(0);
  const [newLogin, setNewLogin] = useState("");
  const [newSenha, setNewSenha] = useState("");
  const [newGrupo, setNewGrupo] = useState("");
  const [newCidade, setNewCidade] = useState([]);
  const [newLimiteAntecedencia, setNewLimiteAntecedencia] = useState("");
  const [newAnoMarcado, setNewAnoMarcado] = useState("");
  const [newMesMarcado, setNewMesMarcado] = useState("");
  const [newDiaMarcado, setNewDiaMarcado] = useState("");
  const [newAnoBloqueado, setNewAnoBloqueado] = useState("");
  const [newMesBloqueado, setNewMesBloqueado] = useState("");
  const [newDiaBloqueado, setNewDiaBloqueado] = useState("");
  const [newObs, setNewObs] = useState("");
  const [newPais, setNewPais] = useState("pt-br");
  const [newConta, setNewConta] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [newVendedor, setNewVendedor] = useState("");

  const [comprovanteLogin, setComprovanteLogin] = useState("");
  const [comprovanteSenha, setComprovanteSenha] = useState("");
  const [comprovanteGrupo, setComprovanteGrupo] = useState("");
  const [comprovanteCidade, setComprovanteCidade] = useState([]);
  const [comprovanteLimiteAntecedencia, setComprovanteLimiteAntecedencia] = useState("");
  const [comprovanteAnoMarcado, setComprovanteAnoMarcado] = useState("");
  const [comprovanteMesMarcado, setComprovanteMesMarcado] = useState("");
  const [comprovanteDiaMarcado, setComprovanteDiaMarcado] = useState("");
  const [comprovanteAnoBloqueado, setComprovanteAnoBloqueado] = useState("");
  const [comprovanteMesBloqueado, setComprovanteMesBloqueado] = useState("");
  const [comprovanteDiaBloqueado, setComprovanteDiaBloqueado] = useState("");
  const [comprovanteObs, setComprovanteObs] = useState("");
  const [comprovanteStatus, setComprovanteStatus] = useState("");
  const [nomeClienteComprovante, setNomeClienteComprovante] = useState("");
  const [contatoClienteComprovante, setContatoClienteComprovante] = useState("");

  const [listaClientesAtivos, setListaClientesAtivos] = useState("");

  const [filtroGrupo, setFiltroGrupo] = useState(-1);
  const [filtroCidade, setFiltroCidade] = useState(-1);
  const [filtroStatus, setFiltroStatus] = useState(-1);
  const [usersList, setUsersList] = useState([]);

  const [openCloseEditStatus, setOpenCloseEditStatus] = useState(false);
  const [estadoDuplicados, setEstadoDuplicados] = useState(false);
  const [comprovanteEnviado, setComprovanteEnviado] = useState(false);
  const [textoBotaoDuplicados, setTextoBotaoDuplicados] = useState("Exibir Duplicados");

  const [clientesList, setClientesList] = useState([]);
  const [parceirosList, setParceirosList] = useState([]);
  const [showAllClientes, setShowAllClientes] = useState(false);

  const [vendedoresList, setVendedoresList] = useState([]);

  const [filterLogin, setFilterLogin] = useState('');

  const cidades = {
    54: 'Brasília',
    55: 'Rio de Janeiro',
    56: 'São Paulo',
    57: 'Recife',
    128: 'Porto Alegre'
  };

  useEffect(() => {
    if (notificationType && notifications[notificationType]) {
      notifications[notificationType]();
      setNotificationType(0);
    }
  }, [notificationType]);

  function revelarNomesCidades(cidadeCodigos) {
    return cidadeCodigos.map((codigo) => cidades[codigo]).filter(Boolean).join(', ');
  }

  async function getClienteDetails(selectedClienteId) {
    try {
      const response = await api.get(`/clienteAgiliza/${selectedClienteId}`);
      setNomeClienteComprovante(response.data.Nome);
      setContatoClienteComprovante(response.data.contato);
    } catch (error) {
      console.error("Error fetching client details", error);
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const sendItemsToEdit = async (userData) => {
    setUserIdMonitorar(userData.id);
    setNewLogin(userData.login);
    setNewSenha(userData.senha);
    setNewGrupo(userData.grupo);
    setNewLimiteAntecedencia(userData.limiteAntecedencia);
    setNewAnoMarcado(userData.anoMarcado);
    setNewMesMarcado(userData.mesMarcado);
    setNewDiaMarcado(userData.diaMarcado);
    setNewAnoBloqueado(userData.anoBloqueado);
    setNewMesBloqueado(userData.mesBloqueado);
    setNewDiaBloqueado(userData.diaBloqueado);
    setNewObs(userData.obs);
    setNewPais(userData.pais);
    setNewConta(userData.conta);
    setNewStatus(userData.status);
    setNewVendedor(userData.vendedor);

    try {
      const newCitiesSplitted =
        typeof userData.cidade === 'string' ? userData.cidade.split(",") : userData.cidade;
      setNewCidade(newCitiesSplitted || []);
    } catch {
      setNewCidade([]);
    }

    await sleep(10);

    try {
      const ids = ["54", "56", "128", "55", "57"];
      ids.forEach((codigo, index) => {
        const checkbox = document.getElementById(`newCheckBox${index + 1}`);
        if (checkbox) {
          checkbox.checked = String(userData.cidade || "").includes(codigo);
        }
      });
    } catch (error) {
      console.log("erro no sendItemsToEdit", error);
    }
  };

  const validateNewForm = () => {
    return !(
      newVendedor === "" ||
      newLogin === "" ||
      newSenha === "" ||
      newCidade.length === 0 ||
      newAnoMarcado === "" ||
      newMesMarcado === "" ||
      newDiaMarcado === "" ||
      newAnoBloqueado === "" ||
      newMesBloqueado === "" ||
      newDiaBloqueado === "" ||
      newGrupo === ""
    );
  };

  const updateNewData = async (id) => {
    if (!validateNewForm()) {
      setNotificationType(10);
      return;
    }

    const res = await api.post('/updateUser', {
      id,
      login: newLogin,
      senha: newSenha,
      grupo: newGrupo,
      cidade: newCidade,
      limiteAntecedencia: newLimiteAntecedencia,
      anoMarcado: newAnoMarcado,
      mesMarcado: newMesMarcado,
      diaMarcado: newDiaMarcado,
      anoBloqueado: newAnoBloqueado,
      mesBloqueado: newMesBloqueado,
      diaBloqueado: newDiaBloqueado,
      obs: newObs,
      pais: newPais,
      conta: newConta,
      status: newStatus,
      vendedor: newVendedor,
      ClienteId: clienteId
    });

    if (res.data.status === true) {
      const newData = usersList.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            id,
            login: newLogin,
            senha: newSenha,
            grupo: newGrupo,
            cidade: newCidade,
            limiteAntecedencia: newLimiteAntecedencia,
            anoMarcado: newAnoMarcado,
            mesMarcado: newMesMarcado,
            diaMarcado: newDiaMarcado,
            anoBloqueado: newAnoBloqueado,
            mesBloqueado: newMesBloqueado,
            diaBloqueado: newDiaBloqueado,
            obs: newObs,
            pais: newPais,
            conta: newConta,
            status: newStatus,
            vendedor: newVendedor,
            ClienteId: clienteId
          };
        }
        return item;
      });

      setUsersList(newData);
      setNotificationType(8);
      await getUsers();
      setOpenCloseEditStatus(false);
    } else {
      setNotificationType(9);
    }
  };

  async function getUsers() {
    const res = await api.get('/clientes?userPermission=99&CPF=05204993010');
    const resCliente = await api.get('/clientesAgiliza');
    const resParceiro = await api.get('/clientesParceiros');
    setParceirosList(resParceiro.data);
    setClientesList(resCliente.data);
    setUsersList(res.data);
  }

  const getVendedoresProdutores = async () => {
    try {
      const resVendedoresProdutores = await api.get('/vendedores-produtores');
      if (resVendedoresProdutores.data && Array.isArray(resVendedoresProdutores.data.data)) {
        const users = resVendedoresProdutores.data.data;
        setVendedoresList(users.filter((user) => user.is_vendedor === 1));
      } else {
        console.error('Formato inesperado da resposta:', resVendedoresProdutores.data);
        NotificationManager.error('Erro ao carregar vendedores e produtores.', 'Erro');
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      NotificationManager.error('Erro ao carregar dados.', 'Erro');
    }
  };

  useEffect(() => {
    if (userPermission === 1) {
      setVendedor(userStatus);
    }
    getVendedoresProdutores();
    getUsers();
  }, [userPermission, userStatus]);

  const deleteUser = async (id) => {
    const res = await api.post('/deletar', { id });
    if (res.data === true) {
      const newItems = usersList.filter((item) => item.id !== id);
      setUsersList(newItems);
      setNotificationType(4);
    } else {
      setNotificationType(5);
    }
  };

  const validateForm = () => {
    return !(
      vendedor === "" ||
      login === "" ||
      senha === "" ||
      cidade.length === 0 ||
      anoMarcado === "" ||
      mesMarcado === "" ||
      diaMarcado === "" ||
      anoBloqueado === "" ||
      mesBloqueado === "" ||
      diaBloqueado === "" ||
      grupo === "" ||
      clienteId === ""
    );
  };

  const insertData = async () => {
    if (!validateForm()) {
      setNotificationType(3);
      return;
    }

    const grupoNum = Number(grupo);

    if (grupoNum === 1) {
      setComprovanteGrupo("INDIVIDUAL");
    } else if (grupoNum === 2) {
      setComprovanteGrupo("GRUPO");
    } else if (grupoNum >= 2 && grupoNum <= 10) {
      setComprovanteGrupo(`GRUPO DE ${grupoNum}`);
    } else {
      setComprovanteGrupo("GRUPO MAIOR QUE 10 OU ERRO!");
    }

    setComprovanteCidade(cidade);
    setComprovanteLimiteAntecedencia(limiteAntecedencia);
    setComprovanteAnoMarcado(anoMarcado);
    setComprovanteMesMarcado(addZeroes(mesMarcado, 2));
    setComprovanteDiaMarcado(addZeroes(diaMarcado, 2));
    setComprovanteAnoBloqueado(anoBloqueado);
    setComprovanteMesBloqueado(addZeroes(mesBloqueado, 2));
    setComprovanteDiaBloqueado(addZeroes(diaBloqueado, 2));
    setComprovanteObs(obs);

    const statusNum = Number(status);
    if (statusNum === 0) {
      setComprovanteStatus("Ativo na fila");
    } else if (statusNum === 1) {
      setComprovanteStatus("Quarentena");
    } else if (statusNum === 2) {
      setComprovanteStatus("Finalista");
    } else {
      setComprovanteStatus("erro!");
    }

    const res = await api.post('/cadastrar', {
      login,
      senha,
      grupo,
      cidade,
      limiteAntecedencia,
      anoMarcado,
      mesMarcado,
      diaMarcado,
      anoBloqueado,
      mesBloqueado,
      diaBloqueado,
      obs,
      pais,
      conta,
      status,
      vendedor,
      ClienteId: clienteId
    });

    if (res.data.status === true) {
      const newUser = {
        id: res.data.insertId,
        login,
        senha,
        grupo,
        cidade,
        limiteAntecedencia,
        anoMarcado,
        mesMarcado,
        diaMarcado,
        anoBloqueado,
        mesBloqueado,
        diaBloqueado,
        obs,
        pais,
        conta,
        vendedor,
        status: 0,
        ClienteId: clienteId
      };

      setUsersList([...usersList, newUser]);

      const resetDate = new Date();
      const resetDatePlus = new Date();
      resetDatePlus.setDate(resetDatePlus.getDate() + 90);

      setAnoMarcado(resetDatePlus.getFullYear());
      setMesMarcado(addZeroes(resetDatePlus.getMonth() + 1, 2));
      setDiaMarcado(addZeroes(resetDatePlus.getDate(), 2));
      setAnoBloqueado(resetDate.getFullYear());
      setMesBloqueado(addZeroes(resetDate.getMonth() + 1, 2));
      setDiaBloqueado(addZeroes(resetDate.getDate(), 2));

      setNotificationType(1);
      setComprovanteEnviado(true);
      setComprovanteLogin(login);
      setComprovanteSenha(senha);
      getClienteDetails(clienteId);
      clearData();
    } else {
      setNotificationType(2);
    }
  };

  const clearData = () => {
    ["checkBox1", "checkBox2", "checkBox3", "checkBox4", "checkBox5"].forEach((id) => {
      const checkbox = document.getElementById(id);
      if (checkbox) checkbox.checked = false;
    });

    setLogin("");
    setSenha("");
    setPais("pt-br");
    setConta("");
    setVendedor("");
    setCidade([]);
    setLimiteAntecedencia("");
    setObs("");
    setGrupo("");
    setStatus(0);
  };

  const arrayOfCity = (cityCode, id) => {
    const checkbox = document.getElementById(`checkBox${id}`);
    if (!checkbox) return;

    if (checkbox.checked === true) {
      setCidade((prev) => [...prev, cityCode]);
    } else {
      setCidade((prev) => prev.filter((cidadeItem) => cidadeItem !== cityCode));
    }
  };

  const newArrayOfCity = (cityCode, id) => {
    const checkbox = document.getElementById(`newCheckBox${id}`);
    if (!checkbox) return;

    if (checkbox.checked === true) {
      setNewCidade((prev) => [...prev, cityCode]);
    } else {
      setNewCidade((prev) => prev.filter((cidadeItem) => cidadeItem !== cityCode));
    }
  };

  const [usuariosDuplicados, setUsuariosDuplicados] = useState([]);
  useEffect(() => {
    const groups = new Map();

    usersList.forEach((user) => {
      const key = String(user.login || "");
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(user);
    });

    const duplicados = Array.from(groups.values())
      .filter((group) => group.length > 1)
      .flat()
      .sort((a, b) => String(a.login).localeCompare(String(b.login)));

    setUsuariosDuplicados(duplicados);
  }, [usersList]);

  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const loginFiltro = filterLogin.trim().toLowerCase();

    const next = usersList.filter((item) => {
      if (loginFiltro !== '') {
        return String(item.login || "").toLowerCase().includes(loginFiltro);
      }

      const cidadeMatch =
        Number(filtroCidade) === -1 || String(item.cidade || "").includes(String(filtroCidade));
      const grupoMatch =
        Number(filtroGrupo) === -1 || Number(item.grupo) === Number(filtroGrupo);
      const statusMatch =
        Number(filtroStatus) === -1 || Number(item.status) === Number(filtroStatus);

      if (
        Number(filtroCidade) === -1 &&
        Number(filtroGrupo) === -1 &&
        Number(filtroStatus) === -1
      ) {
        return Number(item.status) === 0;
      }

      return cidadeMatch && grupoMatch && statusMatch;
    });

    setFilteredData(next);
  }, [usersList, filterLogin, filtroCidade, filtroGrupo, filtroStatus, userIdMonitorar]);

  function copyTextToClipboard(text) {
    const input = document.createElement('input');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  }

  function copyDataAtivo() {
    copyTextToClipboard(listaClientesAtivos);
    setNotificationType(11);
  }

  async function getClientDataAtivo() {
    const res = await api.get('/getDataAtivo');
    const modifiedString = JSON.stringify(res.data).replace(/"([^"]+)":/g, '$1:');
    setListaClientesAtivos(`const persons = ${modifiedString}`);
  }

  function mudarTextoBotao(novoEstado) {
    setTextoBotaoDuplicados(novoEstado ? "Ocultar Duplicados" : "Exibir Duplicados");
  }

  async function descerItem(user, nextUser) {
    const res = await api.post('/descerItem', { user, nextUser });
    if (res.data.status === false) {
      setNotificationType(16);
    } else {
      getUsers();
    }
  }

  async function subirItem(user, backUser) {
    const res = await api.post('/subirItem', { user, backUser });
    if (res.data.status === false) {
      setNotificationType(15);
    } else {
      getUsers();
    }
  }

  async function enviarParaInicio(user) {
    const res = await api.post('/enviarParaInicio', { user });
    if (res.data.status === false) {
      setNotificationType(18);
    } else {
      getUsers();
    }
  }

  async function enviarParaFim(user, tamanhoTotalLista) {
    const res = await api.post('/enviarParaFim', { user, tamanhoTotalLista });
    if (res.data.status === false) {
      setNotificationType(17);
    } else {
      getUsers();
    }
  }

  const handleToggleShowAll = () => {
    setShowAllClientes((prevState) => !prevState);
  };

  const handleClienteSelecionado = (selectedClienteId) => {
    setClienteId(selectedClienteId);
    console.log('Cliente selecionado ID:', selectedClienteId);
  };

  async function handleClienteCriado(novoCliente) {
    setClientesList((prevList) => [...prevList, novoCliente]);
    handleClienteSelecionado(novoCliente.id);
  }

  const handleClick = async (user) => {
    try {
      const response = await api.get(`/agendamento/${user.id}`);
      let agendamentoInicial;
      let isEditMode = false;

      if (response.data.length > 0) {
        const agendamento = response.data[0];

        agendamentoInicial = {
          consuladoEntrevista: agendamento.entrevista ? JSON.parse(agendamento.entrevista).consulado : '',
          dataHorarioEntrevista: agendamento.entrevista ? JSON.parse(agendamento.entrevista).data_horario : '',
          aprovado: agendamento.aprovado,
          clienteId: parseInt(agendamento.cliente_id, 10),
          idDoCliente: user.ClienteId,
          id: agendamento.id,
          email: user.login,
          nome: user.clienteNome,
          vendedor: user.vendedor,
          contato: user.clienteContato,
        };
        isEditMode = true;
      } else {
        const now = new Date();
        const formattedDateTime = now.toISOString().slice(0, 16);

        agendamentoInicial = {
          consuladoEntrevista: '',
          dataHorarioEntrevista: formattedDateTime,
          aprovado: false,
          clienteId: parseInt(user.id, 10),
          email: user.login,
          nome: user.clienteNome,
          idDoCliente: user.ClienteId,
          contato: user.clienteContato,
          vendedor: user.vendedor,
          obs: user.obs,
        };
      }

      openModal(agendamentoInicial, isEditMode);
    } catch (error) {
      console.error('Erro ao verificar agendamento:', error);
    }
  };

  const activeUsers = useMemo(
    () => filteredData.filter((user) => Number(user.status) !== 1),
    [filteredData]
  );

  return (
    <div className={styles.app}>
      <NotificationContainer />
      <Agendamentos />

      <div className={`${styles.corTitulo} ${styles.green}`}>
        <p className={styles.titulo}>CLIENTES</p>
      </div>

      <div className={styles.cadastroClienteContainer}>
        <CreateCliente
          clientesList={clientesList}
          handleToggleShowAll={handleToggleShowAll}
          showAllClientes={showAllClientes}
          parceirosList={parceirosList}
          onClienteSelecionado={handleClienteSelecionado}
          onClienteCriado={handleClienteCriado}
        />
      </div>

      <div className={`${styles.corTitulo} ${styles.red}`}>
        <p className={styles.titulo}>MONITORAR</p>
      </div>

      <div className={styles.cadastroClienteContainer}>
        <div className={styles.containerTituloInput}>
          <input
            className={styles.inputFilter}
            style={{ width: "90%", marginTop: "10px" }}
            type="text"
            onChange={(e) => setLogin(e.target.value)}
            value={login}
            placeholder="Digite o Email"
          />
          <input
            className={styles.inputFilter}
            style={{ width: "90%" }}
            type="text"
            onChange={(e) => setSenha(e.target.value)}
            value={senha}
            placeholder="Digite a senha"
          />
        </div>

        <div className={styles.containerVendedorInput}>
          <div className={styles.containerVendedor}>
            <p className={styles.inputText}>VENDEDOR: </p>
            <select
              onChange={(e) => setVendedor(e.target.value)}
              value={vendedor}
              className={styles.inputFilter}
            >
              <option value="">Selecione um Vendedor</option>
              {vendedoresList.map((v) => (
                <option key={v.id} value={v.cpf}>
                  {v.nome} - {v.cpf}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={styles.divisor}></div>

        <div className={styles.cadastroItems02}>
          <p className={styles.inputTextTitle}>Consulados Dispoíveis*</p>
          <div className={styles.groupCityContainer}>
            <div className={styles.containerCidades}>
              <div className={styles.cityContainer}>
                <label className={styles.containerCb}>
                  <input id="checkBox1" type="checkbox" onChange={() => arrayOfCity("54", 1)} />
                  <span className={styles.checkmark}></span>
                </label>
                <p className={styles.cidadeText}>Brasília</p>
              </div>
              <div className={styles.cityContainer}>
                <label className={styles.containerCb}>
                  <input id="checkBox2" type="checkbox" onChange={() => arrayOfCity("56", 2)} />
                  <span className={styles.checkmark}></span>
                </label>
                <p className={styles.cidadeText}>São Paulo</p>
              </div>
              <div className={styles.cityContainer}>
                <label className={styles.containerCb}>
                  <input id="checkBox3" type="checkbox" onChange={() => arrayOfCity("128", 3)} />
                  <span className={styles.checkmark}></span>
                </label>
                <p className={styles.cidadeText}>Porto Alegre</p>
              </div>
              <div className={styles.cityContainer}>
                <label className={styles.containerCb}>
                  <input id="checkBox4" type="checkbox" onChange={() => arrayOfCity("55", 4)} />
                  <span className={styles.checkmark}></span>
                </label>
                <p className={styles.cidadeText}>Rio de Janeiro</p>
              </div>
              <div className={styles.cityContainer}>
                <label className={styles.containerCb}>
                  <input id="checkBox5" type="checkbox" onChange={() => arrayOfCity("57", 5)} />
                  <span className={styles.checkmark}></span>
                </label>
                <p className={styles.cidadeText}>Recife</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.divisor}></div>

        <div className={styles.cadastroItems03}>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Dias de Antecedência*</p>
            <input
              className={styles.inputFilter}
              style={{ width: "60px" }}
              type="text"
              onChange={(e) => setLimiteAntecedencia(e.target.value)}
              value={limiteAntecedencia}
              placeholder="Limite de antecedência"
            />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>País</p>
            <select
              onChange={(e) => setPais(e.target.value)}
              value={pais}
              className={styles.inputFilter}
              style={{ width: "160px" }}
            >
              {countriesList.map((items) => (
                <option key={items.country} value={items.country}>
                  {items.country}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={styles.cadastroItems03}>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Data limite</p>
            <input
              className={styles.inputFilter}
              style={{ width: "60px" }}
              type="text"
              onChange={(e) => setAnoMarcado(e.target.value)}
              value={anoMarcado}
              placeholder="Digite o ano"
            />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Mês</p>
            <input
              className={styles.inputFilter}
              style={{ width: "60px" }}
              type="text"
              onChange={(e) => setMesMarcado(e.target.value)}
              value={mesMarcado}
              placeholder="Digite o mês"
            />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Dia</p>
            <input
              className={styles.inputFilter}
              style={{ width: "60px" }}
              type="text"
              onChange={(e) => setDiaMarcado(e.target.value)}
              value={diaMarcado}
              placeholder="Digite o dia"
            />
          </div>
        </div>

        <div className={styles.cadastroItems03}>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Data inicio</p>
            <input
              className={styles.inputFilter}
              style={{ width: "60px" }}
              type="text"
              onChange={(e) => setAnoBloqueado(e.target.value)}
              value={anoBloqueado}
              placeholder="Digite o ano"
            />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Mês</p>
            <input
              className={styles.inputFilter}
              style={{ width: "60px" }}
              type="text"
              onChange={(e) => setMesBloqueado(e.target.value)}
              value={mesBloqueado}
              placeholder="Digite o mês"
            />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Dia</p>
            <input
              className={styles.inputFilter}
              style={{ width: "60px" }}
              type="text"
              onChange={(e) => setDiaBloqueado(e.target.value)}
              value={diaBloqueado}
              placeholder="Digite o dia"
            />
          </div>
        </div>

        <div className={styles.divisor}></div>

        <div className={styles.cadastroItems04}>
          <div className={styles.itemContainer}>
            <p className={styles.inputText}>Observações</p>
            <textarea
              onChange={(e) => setObs(e.target.value)}
              value={obs}
              className={styles.inputFilter}
              style={{ width: "90%", height: "auto", minHeight: "200px" }}
              placeholder="Digite uma observação"
            ></textarea>
          </div>
        </div>

        <div className={styles.divisor}></div>

        <div className={styles.cadastroItems05}>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Grupo*</p>
            <input
              className={styles.inputFilter}
              style={{ width: "60px" }}
              type="text"
              onChange={(e) => setGrupo(e.target.value)}
              value={grupo}
              placeholder="1 ou 2"
            />
          </div>
          <div className={styles.containerTituloInput}>
            <p className={styles.inputText}>Status</p>
            <select
              onChange={(e) => setStatus(Number(e.target.value))}
              value={status}
              className={styles.inputFilter}
              style={{ width: "160px" }}
            >
              <option value={0}>Ativo</option>
              <option value={1}>Quarentena</option>
              <option value={2}>Finalista</option>
              <option value={3}>Senha errada</option>
              <option value={4}>Garantido</option>
              <option value={5}>Pagar taxa</option>
            </select>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <button onClick={insertData} className={styles.cadastroCliente}>
            MONITORAR
          </button>
        </div>
      </div>

      {comprovanteEnviado ? (
        <div
          className={`${styles.cadastroClienteContainer} ${styles.copiar}`}
          onClick={() => {
            const r = document.createRange();
            const node = document.getElementById('copiar');
            if (!node) return;
            r.selectNode(node);
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(r);
            try {
              document.execCommand('copy');
              window.getSelection().removeAllRanges();
              setNotificationType(19);
            } catch (err) {
              console.log('Unable to copy!', err);
            }
          }}
        >
          <div className={styles.copiarTop}>COMPROVANTE (clica para copiar)</div>
          <p id="copiar" className={styles.copiarText}>
            Nome: {nomeClienteComprovante}
            <br />
            Contato: {contatoClienteComprovante}
            <br />
            <br />
            {comprovanteLogin}
            <br />
            {comprovanteSenha}
            <br />
            <br />
            {comprovanteAnoMarcado}-{comprovanteMesMarcado}-{comprovanteDiaMarcado} à {comprovanteAnoBloqueado}-{comprovanteMesBloqueado}-{comprovanteDiaBloqueado}
            <br />
            {comprovanteGrupo} | {revelarNomesCidades(comprovanteCidade)}
            <br />
            Antecedência mínima: {comprovanteLimiteAntecedencia}
            <br />
            obs: {comprovanteObs}
            <br />
            <br />
            Status: {comprovanteStatus}
          </p>
        </div>
      ) : null}

      <div className={`${styles.corTitulo} ${styles.bluea}`}>
        <p className={styles.titulo}>Fila de monitoramento</p>
      </div>

      <div className={styles.cadastroClienteContainer}>
        <div className={styles.tituloContainer}></div>
        <div className={styles.divisor}></div>

        <div className={styles.filtroDeClientesContainer}>
          <div className={styles.containerTituloInput}>
            <input
              className={`${styles.inputStyle} ${styles.inputFilter}`}
              type="text"
              onChange={(e) => setFilterLogin(e.target.value)}
              value={filterLogin}
              placeholder="Digite o login do usuário que deseja encontrar!"
            />
          </div>

          <div className={styles.filterOptionsContainer}>
            <div>
              <select
                className={`${styles.inputStyleMin} ${styles.inputSpacing}`}
                onChange={(e) => setFiltroGrupo(Number(e.target.value))}
              >
                <option value={-1}>Grupo</option>
                <option value={1}>Individual</option>
                <option value={2}>Coletivo</option>
              </select>
            </div>
            <div>
              <select
                className={styles.inputStyleMin}
                onChange={(e) => setFiltroCidade(Number(e.target.value))}
              >
                <option value={-1}>Cidade</option>
                <option value={54}>Brasília</option>
                <option value={56}>São Paulo</option>
                <option value={128}>Porto Alegre</option>
                <option value={55}>Rio de Janeiro</option>
                <option value={57}>Recife</option>
              </select>
            </div>
            <div>
              <select
                className={`${styles.inputStyleMin} ${styles.inputSpacing}`}
                onChange={(e) => setFiltroStatus(Number(e.target.value))}
              >
                <option value={0}>Ativos</option>
                <option value={1}>Quarentena</option>
                <option value={2}>Finalistas</option>
                <option value={3}>Senha errada</option>
                <option value={4}>Garantido</option>
                <option value={5}>Pagar taxa</option>
              </select>
            </div>
          </div>
        </div>

        <div className={styles.divisor}></div>

        <div className={styles.usersListContainer}>
          {activeUsers.map((user, index) => {
            const nextUser = activeUsers[index + 1];
            const backUser = activeUsers[index - 1];
            const tamanhoTotalLista = activeUsers.length;

            let dataHorarioEntrevista = '';
            if (user.entrevista) {
              try {
                const entrevista = JSON.parse(user.entrevista);
                if (entrevista.data_horario) {
                  dataHorarioEntrevista = format(parseISO(entrevista.data_horario), 'dd-MM-yy');
                }
              } catch (error) {
                console.error('Erro ao parsear entrevista:', error);
              }
            }

            const vendedorEncontrado = vendedoresList.find((v) => v.cpf === user.vendedor);
            const vendedorNome = vendedorEncontrado ? vendedorEncontrado.nome : 'Vendedor não encontrado';

            return (
              <div key={user.id} className={styles.userContainer}>
                <div className={styles.userContainer2}>
                  <div className={styles.onOffIconContainer}>
                    <div className={Number(user.status) === 0 ? styles.groupAmountVerde : styles.groupAmountVermelho}>
                      <p className={styles.icon}>{user.grupo}</p>
                    </div>
                  </div>

                  <div className={styles.loginContainer}>
                    <p>{user.login} - </p>
                    {String(user.vendedor) !== "0" ? (
                      <p className={styles.icon2}>{vendedorNome}</p>
                    ) : null}
                  </div>
                </div>

                <div className={styles.iconeslat}>
                  <div className={styles.editContainer}>
                    <p
                      style={{
                        padding: "10px",
                        backgroundColor: "var(--corPrimaria)",
                        borderRadius: "10px",
                        color: "white",
                        fontSize: "1.2rem"
                      }}
                    >
                      {dataHorarioEntrevista.split('T')[0]}
                    </p>

                    <div
                      onClick={() => {
                        setOpenCloseEditStatus(true);
                        sendItemsToEdit(user);
                      }}
                      className={styles.editIconBox}
                      style={{ backgroundColor: "var(--corPrimaria)" }}
                    >
                      <p className={styles.icon2}><FaPencilAlt /></p>
                    </div>

                    <div className={`${styles.editIconBox} ${styles.yellow}`} onClick={() => handleClick(user)}>
                      <p className={styles.icon2}><FaExclamation /></p>
                    </div>

                    <div className={styles.editIconBox} style={{ backgroundColor: "var(--corPrimaria)" }}>
                      <div className={styles.deleteContainer}>
                        <Usuarios
                          user={user}
                          nextUser={nextUser}
                          backUser={backUser}
                          descerItem={descerItem}
                          subirItem={subirItem}
                          enviarParaFim={enviarParaFim}
                          enviarParaInicio={enviarParaInicio}
                          tamanhoTotalLista={tamanhoTotalLista}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.userContainer1}>
                  <div className={styles.obsContainer}>
                    <p>{user.obs}</p>
                  </div>
                  <div className={styles.obsContainer}>
                    <p>{user.cidade}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div>
        <button
          className={styles.mostrarDuplicados}
          onClick={() => {
            const novoEstado = !estadoDuplicados;
            setEstadoDuplicados(novoEstado);
            mudarTextoBotao(novoEstado);
          }}
        >
          {textoBotaoDuplicados}
        </button>
      </div>

      {estadoDuplicados ? (
        <div className={styles.cadastroClienteContainer}>
          <div className={styles.tituloContainer}>
            <p className={styles.titulo}>Lista de Duplicados</p>
          </div>
          <div className={styles.divisor}></div>
          <div className={styles.usersListContainer}>
            {usuariosDuplicados.map((user) => (
              <div key={user.id} className={styles.userContainer}>
                <div className={styles.onOffIconContainer}>
                  <div className={Number(user.status) === 0 ? styles.groupAmountVerde : styles.groupAmountVermelho}>
                    <p className={styles.icon}>{user.grupo}</p>
                  </div>
                </div>

                <div className={styles.loginContainer}>
                  <p>{user.login}</p>
                </div>

                <div className={styles.iconeslat}>
                  <div className={styles.editContainer}>
                    <div
                      onClick={() => {
                        setOpenCloseEditStatus(true);
                        sendItemsToEdit(user);
                      }}
                      className={styles.editIconBox}
                    >
                      <p className={styles.icon2}><FaPencilAlt /></p>
                    </div>
                  </div>

                  <div className={styles.deleteContainer}>
                    <div onClick={() => deleteUser(user.id)} className={styles.deleteIconBox}>
                      <p className={styles.icon2}><FaTrashAlt /></p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      <div className={`${styles.corTitulo} ${styles.bluea}`}>
        <p className={styles.titulo}>Listas de Clientes</p>
      </div>

      <div className={styles.cadastroClienteContainer}>
        <div>
          <p className={styles.topText}><strong>Ativos</strong></p>
          <input className={`${styles.inputStyle} ${styles.inputFilter}`} value={listaClientesAtivos} type="text" readOnly />
        </div>
        <div className={styles.buttonsGroup}>
          <button className={styles.buttonMenor} onClick={getClientDataAtivo}>Atualizar</button>
          <button className={styles.buttonMenor} onClick={copyDataAtivo}>Copiar</button>
        </div>
      </div>

      {openCloseEditStatus ? (
        <div className={styles.backgroundBlur}>
          <div className={styles.generalContainer}>
            <div onClick={() => setOpenCloseEditStatus(false)} className={styles.closeButton}>
              <p className={styles.icon}><IoCloseSharp /></p>
            </div>

            <div className={`${styles.cadastroClienteContainer} ${styles.cadastroClienteContainerWithoutMargin}`}>
              <div className={styles.divisor}></div>

              <div className={styles.cadastroItems01}>
                <div className={styles.containerTituloInput}>
                  <input className={styles.inputStyle} type="text" onChange={(e) => setNewLogin(e.target.value)} value={newLogin} placeholder="Digite o Email" />
                </div>
                <div className={styles.containerTituloInput}>
                  <input className={styles.inputStyle} type="text" onChange={(e) => setNewSenha(e.target.value)} value={newSenha} placeholder="Digite a senha" />
                </div>
                <div className={styles.containerVendedorInput}>
                  <div className={styles.containerVendedor}>
                    <p className={styles.inputText}>VENDEDOR: </p>
                    <select
                      onChange={(e) => setNewVendedor(e.target.value)}
                      value={newVendedor}
                      className={styles.inputStyleVendedor}
                    >
                      <option value="">Selecione um Vendedor</option>
                      {vendedoresList.map((v) => (
                        <option key={v.id} value={v.cpf}>
                          {v.nome} - {v.cpf}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className={styles.cadastroItems02}>
                <div className={styles.groupCityContainer}>
                  <div className={styles.containerCidades}>
                    <div className={styles.cityContainer}>
                      <label className={styles.containerCb}>
                        <input id="newCheckBox1" type="checkbox" onChange={() => newArrayOfCity("54", 1)} />
                        <span className={styles.checkmark}></span>
                      </label>
                      <p className={styles.cidadeText}>Brasília</p>
                    </div>
                    <div className={styles.cityContainer}>
                      <label className={styles.containerCb}>
                        <input id="newCheckBox2" type="checkbox" onChange={() => newArrayOfCity("56", 2)} />
                        <span className={styles.checkmark}></span>
                      </label>
                      <p className={styles.cidadeText}>São Paulo</p>
                    </div>
                    <div className={styles.cityContainer}>
                      <label className={styles.containerCb}>
                        <input id="newCheckBox3" type="checkbox" onChange={() => newArrayOfCity("128", 3)} />
                        <span className={styles.checkmark}></span>
                      </label>
                      <p className={styles.cidadeText}>Porto Alegre</p>
                    </div>
                    <div className={styles.cityContainer}>
                      <label className={styles.containerCb}>
                        <input id="newCheckBox4" type="checkbox" onChange={() => newArrayOfCity("55", 4)} />
                        <span className={styles.checkmark}></span>
                      </label>
                      <p className={styles.cidadeText}>Rio de Janeiro</p>
                    </div>
                    <div className={styles.cityContainer}>
                      <label className={styles.containerCb}>
                        <input id="newCheckBox5" type="checkbox" onChange={() => newArrayOfCity("57", 5)} />
                        <span className={styles.checkmark}></span>
                      </label>
                      <p className={styles.cidadeText}>Recife</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.divisor}></div>

              <div className={styles.cadastroItems03}>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Dias de Antecedência*</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewLimiteAntecedencia(e.target.value)} value={newLimiteAntecedencia} placeholder="Digite o limite de antecedência" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>País</p>
                  <select onChange={(e) => setNewPais(e.target.value)} value={newPais} className={styles.selectStyle}>
                    {countriesList.map((items) => (
                      <option key={items.country} value={items.country}>{items.country}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className={styles.cadastroItems03}>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Data limite</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewAnoMarcado(e.target.value)} value={newAnoMarcado} placeholder="Digite o ano" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Mês</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewMesMarcado(e.target.value)} value={newMesMarcado} placeholder="Digite o mês" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Dia</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewDiaMarcado(e.target.value)} value={newDiaMarcado} placeholder="Digite o dia" />
                </div>
              </div>

              <div className={styles.cadastroItems03}>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Data inicio</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewAnoBloqueado(e.target.value)} value={newAnoBloqueado} placeholder="Digite o ano" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Mês</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewMesBloqueado(e.target.value)} value={newMesBloqueado} placeholder="Digite o mês" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Dia</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewDiaBloqueado(e.target.value)} value={newDiaBloqueado} placeholder="Digite o dia" />
                </div>
              </div>

              <div className={styles.divisor}></div>

              <div className={styles.cadastroItems04}>
                <div className={styles.itemContainer}>
                  <p className={styles.inputText}>Observações</p>
                  <textarea onChange={(e) => setNewObs(e.target.value)} value={newObs} className={styles.textArea} placeholder="Digite uma observação"></textarea>
                </div>
              </div>

              <div className={styles.divisor}></div>

              <div className={styles.cadastroItems05}>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Grupo*</p>
                  <input className={styles.inputStyleMin} type="text" onChange={(e) => setNewGrupo(e.target.value)} value={newGrupo} placeholder="1 ou 2" />
                </div>
                <div className={styles.containerTituloInput}>
                  <p className={styles.inputText}>Status</p>
                  <select onChange={(e) => setNewStatus(e.target.value)} value={newStatus} className={styles.inputStyleMin}>
                    <option value={0}>Ativo</option>
                    <option value={1}>Quarentena</option>
                    <option value={2}>Finalista</option>
                    <option value={3}>Senha errada</option>
                    <option value={4}>Garantido</option>
                    <option value={5}>Pagar taxa</option>
                  </select>
                </div>
              </div>

              <div className={styles.buttonContainer}>
                <button
                  onClick={() => {
                    updateNewData(userIdMonitorar);
                    getUsers();
                  }}
                  className={styles.cadastroCliente}
                >
                  Salvar Alterações
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <div className={styles.rodape}></div>
    </div>
  );
}

export default Monitorar;